// Prefer generated SaaS fixtures if available; adapt them to original shapes
import classesFixture from '../Data/saas/generated/classes.json';
import studentsFixture from '../Data/saas/generated/students.json';

export const subjects = ['中文', '英文', '數學', '科學', '歷史', '地理', '體育', '音樂', '美術'];

export const generateSubjectGrades = () =>
  subjects.map(subject => ({
    subject,
    grade: Math.floor(Math.random() * 40) + 60,
    assignment: Math.floor(Math.random() * 30) + 70,
    exam: Math.floor(Math.random() * 35) + 65
  }));

// Build a simple class code from fixture class name (e.g., J1A, S3B)
const fixtureClassCodeById = new Map(
  classesFixture.map(c => [c.classId, c.name])
);

// Export class codes list used by UI filters
export const classes = Array.from(
  new Set(classesFixture.map(c => c.name))
).slice(0, 20);

const photos = [
  'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop&crop=face',
  'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face'
];

export const generateStudents = () => {
  // Take first 20 classes by code and map fixture students into UI-ready items
  const allowedClassCodes = new Set(classes);
  const byCode = studentsFixture
    .map(s => ({
      ...s,
      classCode: fixtureClassCodeById.get(s.classId) || 'S1A'
    }))
    .filter(s => allowedClassCodes.has(s.classCode));

  return byCode.map((s, idx) => ({
    id: s.studentId,
    name: s.name,
    englishName: '',
    class: s.classCode,
    studentId: s.studentCode || s.studentId,
    photo: photos[idx % photos.length],
    status: Math.random() > 0.8 ? 'absent' : Math.random() > 0.9 ? 'late' : 'present',
    grades: generateSubjectGrades(),
    attendance: Math.floor(Math.random() * 5) + 90
  }));
};